__webpack_require__.p = "/book/_next/";